import type { ShadowComparisonResult, ShadowTallySummary } from "@expert/gaia";

import { useMemo } from "react";

import { useAnalytics } from "@/analytics";

/**
 * Business-analytic callbacks for the Simplr websocket shadow dark launch:
 *
 * - `onShadowComparison` emits `SimplrWebsocketShadowComparison` for each message difference.
 * - `onShadowSummary` emits `SimplrWebsocketShadowSummary`, the ~5 min aggregate of ALL comparisons
 *   (equal included) plus per-side delivery counts of uncompared events like call-transcript, so EDP can
 *   compute a match rate and transcript parity.
 *
 * Memoized so the shadow effect downstream does not re-run on every render.
 */
export function useSimplrShadowAnalytics() {
    const { dispatcher } = useAnalytics();

    return useMemo(
        () => ({
            onShadowComparison: (result: ShadowComparisonResult) => {
                void dispatcher.dispatchBusinessEvent("SimplrWebsocketShadowComparison", { ...result });
            },
            onShadowSummary: (summary: ShadowTallySummary) => {
                void dispatcher.dispatchBusinessEvent("SimplrWebsocketShadowSummary", { ...summary });
            },
        }),
        [dispatcher],
    );
}
